var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.087 18.718C2.90841 18.7005 2.73061 18.6758 2.554 18.644C2.42429 18.6208 2.303 18.5638 2.20233 18.4787C2.10167 18.3937 2.02518 18.2836 1.98057 18.1597C1.93596 18.0357 1.92481 17.9021 1.94823 17.7724C1.97165 17.6428 2.02883 17.5215 2.114 17.421C2.52426 16.9373 2.80442 16.3571 2.928 15.735C2.951 15.62 2.906 15.418 2.674 15.192C1.024 13.587 0 11.41 0 9C0 3.97 4.428 0 9.75 0C15.072 0 19.5 3.97 19.5 9C19.5 14.03 15.072 18 9.75 18C8.917 18 8.107 17.903 7.333 17.721C6.06785 18.5161 4.57381 18.8669 3.087 18.718Z",
    fill: "#00BB31"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSms);
export default __webpack_public_path__ + "static/media/sms.7bd7cbe5884d6282b7b88e4fde6ccc7b.svg";
export { ForwardRef as ReactComponent };